import * as actionTypes from './actionTypes';

const initialState = {
  isLoading: false,
  hasError: false,
  news: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH:
      return {
        ...state,
        // only show loading indicator on initial load
        isLoading: state.news.length === 0,
      };
    case actionTypes.FETCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        news: action.news,
      };
    case actionTypes.FETCH_ERROR:
      return {
        ...state,
        isLoading: false,
        hasError: true,
      };
    default:
      return state;
  }
};
